<p-overlayPanel #op [showCloseIcon]="false"
                [dismissable]="true" [styleClass]="'notification-overlay '+(loading?'loading':'')">
  <ng-template pTemplate  *ngIf="this.enabled">
    <ng-template ngFor let-notif [ngForOf]="notifications" let-index="index">
      <div [class]="'notification-item '+notif.state">
        <div class="left">
          <i class="icon" [class]="notif.icon"></i>
        </div>
        <div class="center">
          <div class="text"><span class="ql-editor ql-cc-container" [innerHTML]="notif.content | safeHtml"></span></div>
          <div class="date">{{notif.dateCreation| date: 'dd/MM/yy HH:mm'}}</div>
        </div>
        <div class="right">
          <button class="btt-notif btt-notif-download" pButton icon="fa fa-download"
                  [disabled]="loading"
                  *ngIf="(notif.type == TYPE.REPORT || notif.type == TYPE.RECAP) && notif.state == STATE.TREATED"
                  (click)="relaunchDownload(notif)"
                  [pTooltip]="('notification.btt.download'|translate)+(notif.type == TYPE.REPORT?' Report':' Recap')"
                  tooltipPosition="left"></button>
          <button class="btt-notif btt-notif-close" pButton icon="fa-sharp fa-solid fa-xmark"
                  [disabled]="loading"
                  (click)="removeNotif(notif, index, op)" [style.alignSelf]="'end'"
                  [pTooltip]="'notification.btt.delete'|translate"
                  tooltipPosition="left"></button>
        </div>
      </div>
    </ng-template>
    <div *ngIf="this.enabled&&notifications.length==0" [class]="'notification-item '">
      <div class="left">
      </div>
      <div class="center">
        <div class="text"> &nbsp;</div>
      </div>
      <div class="right">
      </div>
    </div>
    <div class="footer">
      <div class="left">
        <i class="icon fa-solid fa-clock"></i>
      </div>
      <div class="center">
        <div class="date">{{currentDate| date: 'dd/MM/yy HH:mm:ss'}}</div>
      </div>
      <div class="right">
        <button class="btt-notif btt-notif-clear" pButton icon="fa-bell-slash fa-solid fa-ban"
                [disabled]="loading"
                (click)="removeAllNotif(op);" [style.alignSelf]="'end'"
                [pTooltip]="'notification.btt.delete_all'|translate"
                tooltipPosition="left"></button>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
<button *ngIf="this.enabled&&notifications.length > 0"
        pButton pRipple icon="fa-solid fa-bell" type="button" class="p-button-info p-button-text"
        (click)="op.toggle($event)" [disabled]="notifications.length == 0"
        pBadge [value]="(notifications.length<100?notifications.length:99)+''"
></button>
<button *ngIf="this.enabled&&notifications.length == 0"
        pButton pRipple icon="fa-solid fa-bell" type="button" class="p-button-info p-button-text"
        (click)="op.toggle($event)" [disabled]="notifications.length == 0"
></button>
